const SDK_VERSION = '7.115.0';

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
